import { useQuery } from '@tanstack/react-query';

import getCurrentUserId from '@/utils/user/getCurrentUserId';
import { freePassQueries } from '../api/freePassQueries';
import { selectActivePromo } from '../helpers/promoHelpers';
import useFreePassEnabled from './useFreePassEnabled';

const useActivePromoQuery = () => {
  const enabled = useFreePassEnabled();
  const userId = getCurrentUserId();

  return useQuery({
    ...freePassQueries.promos(userId),
    select: selectActivePromo,
    enabled: enabled && Boolean(userId),
  });
};

export default useActivePromoQuery;
